/**
 * Retired path. Identity matching is the Matching tab of People → Connections
 *; bookmarks keep resolving.
 */

import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/_authed/tenants/$slug/settings/identity-matching")({
  beforeLoad: ({ params }) => {
    throw redirect({ to: "/tenants/$slug/directory/matching", params: { slug: params.slug } });
  },
});
